import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=24c8be56&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=24c8be56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8be56",
  null
  
)

export default component.exports